module.exports = "<div class=\"top-menu\">\r\n  <a class=\"top-menu-item\" routerLink=\"/dashboard\" routerLinkActive=\"active\">{{ 'dashboard' | translate }}</a>\r\n  <a class=\"top-menu-item\" routerLink=\"/employees\" routerLinkActive=\"active\">{{ 'employees'  | translate }}</a>\r\n  <a class=\"top-menu-item\" routerLink=\"/clients\" routerLinkActive=\"active\">{{ 'clients' | translate }}</a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/container/views/TopMenuComponent/topMenu.component.html
// module id = ./src/app/modules/container/views/TopMenuComponent/topMenu.component.html
// module chunks = main